import { graphql, useStaticQuery } from "gatsby";
import { get } from "lodash";
import styled from "styled-components";
import React, { useState } from "react";
import { H4, H5, H6 } from "@upsolve/ui";

import withViewportWatch from "../analytics/withViewportWatch";
import trackComponentImpression from "../analytics/trackComponentImpression";
import trackComponentAction from "../analytics/trackComponentAction";
import getMyUpsolveEntryUrl from "../Links/getMyUpsolveEntryUrl";
import { MyUpsolveButtonLink } from "../Links/MyUpsolveLink";
import ImageInContext from "../Media/ImageInContext";

const trackingProps = {
  componentName: "CTAFamousDebtors",
  componentVersion: 0,
};

const CTAFamousDebtors = (props) => {
  // Debtors Image
  const data = useStaticQuery(graphql`
    query CTAFamousDebtors {
      debtors: file(base: { eq: "famous-debtors.png" }) {
        childImageSharp {
          fluid(quality: 20) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  // Impression Tracking
  const [impressionTracked, setImpressionTracked] = useState(false);
  if (props.isInViewport && !impressionTracked) {
    setImpressionTracked(true);
    props.stopWatcher();
    trackComponentImpression(trackingProps);
  }

  return (
    <CTAFamousDebtorsWrapper dataTestId={props.dataTestId}>
      <H4 as="p">We know bankruptcy can be emotionally hard. That’s why we started Upsolve.</H4>
      <ImageInContext
        alt={get(data.debtors, "altText")}
        src={get(data.debtors, "childImageSharp.file.url")}
        fluid={get(data.debtors, "childImageSharp.fluid")}
      />
      <H6 as="p">Countless Americans who file bankruptcy go onto live successful lives!</H6>
      <MyUpsolveButtonLink
        aria-busy="false"
        href={getMyUpsolveEntryUrl({ triggeredByActionId: "ctaFamousDebtors.myUpsolveNavigation" })}
        onClick={() =>
          trackComponentAction({
            ...trackingProps,
            actionId: "ctaFamousDebtors.myUpsolveNavigation",
            actionMethod: "click",
          })
        }
        size="lg"
      >
        Get Free Bankruptcy Help
      </MyUpsolveButtonLink>
    </CTAFamousDebtorsWrapper>
  );
};

const CTAFamousDebtorsWrapper = styled.div.attrs((props) => ({
  "data-test-id": props.dataTestId,
}))`
  background: ${(props) => props.theme.colors.white[700]};
  border-radius: 4px;
  padding: 1em;
  h4,
  h5,
  h6,
  p {
    text-align: center;
    padding: 0 1em;
  }
  a {
    margin: 1em;
    font-weight: 700;
  }
`;

export default withViewportWatch(CTAFamousDebtors);
